import React, { useEffect } from "react";
import "../styles/Pages.css";

function Twitter() {
  useEffect(() => {
    // Load Twitter widget script
    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;
    script.charset = "utf-8";
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector(
        'script[src="https://platform.twitter.com/widgets.js"]',
      );
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <main className="page-content">
      <div className="page-header">
        <h1>iHariprabodham on Twitter</h1>
        <p className="header-subtitle">
          Follow us for latest updates and announcements
        </p>
      </div>

      <div className="page-body">
        <div className="twitter-container">
          {/* Twitter Timeline Embed */}
          <div className="twitter-section">
            <h2>Latest Tweets</h2>
            <div className="twitter-embed">
              <a
                className="twitter-timeline"
                data-height="600"
                data-theme="light"
                data-chrome="noheader nofooter noborders"
                href="https://twitter.com/iHariPrabodham?ref_src=twsrc%5Etfw"
              >
                Tweets by iHariPrabodham
              </a>
            </div>
          </div>

          {/* External Link */}
          <div className="twitter-cta">
            <p>Follow us on Twitter/X</p>
            <a
              href="https://x.com/iHariPrabodham"
              target="_blank"
              rel="noopener noreferrer"
              className="twitter-btn"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                width="24"
                height="24"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.207-6.807-5.966 6.807H2.25l7.73-8.835L1.13 2.25h6.882l4.791 6.318 5.452-6.318zM17.15 18.738h1.828L6.122 4.146H4.231l12.919 14.592z" />
              </svg>
              Open on X (Twitter)
            </a>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Twitter;
